/**
 * @generated SignedSource<<e6530dd85db604d1be1600d1b0efcda7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestedMedicationsFragment$data = {
  readonly requestedMedications: ReadonlyArray<{
    readonly mainSubstance: string | null;
    readonly name: string;
    readonly packageSize: string | null;
    readonly pharmaCode: number | null;
    readonly productUrl: any | null;
  }> | null;
  readonly " $fragmentType": "RequestedMedicationsFragment";
};
export type RequestedMedicationsFragment$key = {
  readonly " $data"?: RequestedMedicationsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestedMedicationsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestedMedicationsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RequestedMedication",
      "kind": "LinkedField",
      "name": "requestedMedications",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mainSubstance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "packageSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pharmaCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "38eab8c672f062552b024b8601ecc118";

export default node;
